import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { usePostContext } from './PostContext';
import Navigation from '@components/Shared/Navigation';
import { colorsGrey } from '@src/theme/chakraTheme/colors';
import {
  FeaturedPostDataFragment,
  TagsPostDataFragment,
} from '@src/generated/graphql';
import SEO from '@components/SEO';

const DynamicPostSidebar = dynamic(
  () => import('@components/Post/PostSidebar')
);
const DynamicPostContent = dynamic(
  () => import('@components/Post/PostContent')
);

const Post: React.FC = () => {
  const { post, categories } = usePostContext();
  const { asPath } = useRouter();
  return (
    <>
      <SEO
        title={post.title}
        description={post.description}
        image={post.mainPhoto?.asset?.url}
        url={asPath}
      />
      <Navigation />
      <Flex bgColor={colorsGrey[50]} justify="center">
        <Flex
          mt={['81px', null, '70px']}
          pt="42px"
          pb="50px"
          px="20px"
          direction={['column', null, 'row']}
          maxW={{ base: '960px', lg: '1180px' }}
        >
          <DynamicPostContent />
          <DynamicPostSidebar
            categories={categories}
            featuredPosts={
              (post.featuredPosts as FeaturedPostDataFragment[]) ?? []
            }
            tags={(post.tags as TagsPostDataFragment[]) ?? []}
          />
        </Flex>
      </Flex>
    </>
  );
};

export default Post;
